export default __webpack_public_path__ + "static/media/image.axis-tuition-management-system.a5337091.png";